export const DETAILS_SECTION_WIDTH = 215;
